// extracted by mini-css-extract-plugin
export default {"tableContainer":"FailedImportsList_tableContainer__z3uJS","table":"FailedImportsList_table__Pr2xr","popover":"FailedImportsList_popover__p2Vqf"};